import _ from "lodash";

export type Constructor<T = any> = new (...args: any[]) => T;
export type Class<T = any> = InstanceType<Constructor<T>>;

/**
 * Return true if given value is not null or undefined
 */
export function isDefined(value: any): boolean {
	return value != null;
}

/**
 * Return true if given value is null or NaN
 */
export function isNullOrNaN(value: number): boolean {
	return value === null || isNaN(value);
}

/**
 * Return true if given value is null or undefined (not exact equals)
 */
export function isNullOrUndefined(value: any): boolean {
	return value == null;
}

/**
 * Return true if the given objects are equal
 * @param emptyIsNull - if specified, then an empty object is the same as null or undefined
 */
export function objectsAreEqual(a: object, b: object, emptyIsNull = false): boolean {
	if (emptyIsNull) {
		if (_.isEmpty(a)) {
			a = null;
		}

		if (_.isEmpty(b)) {
			b = null;
		}
	}

	return _.isEqual(a, b);
}

/** 
 * return true if type of argument is boolean
 */
export function isBoolean(n: any): boolean {
	return typeof n === "boolean";
}
/**
 * convert string boolean ("false", "true") to boolean or return original value
 */
export function stringBoolean2Boolean(val: string | any): boolean | any {
	return val === "true" ? true : val === "false" ? false : val;
}
